export default __webpack_public_path__ + "static/media/FiraSans-Regular.4d11e51c.woff2";